module.exports = __webpack_public_path__ + "static/media/tabs-right.c8b70780.jpg";